export default __webpack_public_path__ + "static/media/1280px-Starry_Internet_logo_black.d9ac31e0.png";